module.exports = __webpack_public_path__ + "img/Hamstra.318f736e.jpeg";